module.exports = __webpack_public_path__ + "img/35816309000139.17261865.png";